import React from 'react';
import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {doppeActionTypeSubscribeMetaData} from './doppe-action-type-subscribe-metadata';

export const doppeActionTypeSubscribeViewerMetadata = doppeActionTypeDefineViewerMetadata(doppeActionTypeSubscribeMetaData, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeSubscribeWidget: (await import('./doppe-action-type-subscribe-widget/doppe-action-type-subscribe-widget')).DoppeActionTypeSubscribeWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeSubscribeWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeSubscribeWidget
                {...renderProps}
            />
        )
    }
})